<div class="sync-fusion-main-container">
    <app-header-content-help-text Heading="Integration Status"
        helpText="Get your status here"></app-header-content-help-text>
    <div class="grid-container" *ngIf="dynamicHeaders?.length > 0">
        <!-- <app-syncfusion-grid [reportName]="" [dynamic_headers]="dynamicHeaders"
            [data]="data" *ngIf="tableDataFetched" [freezeColumns]="0"></app-syncfusion-grid> -->
        <app-grid-reusable-molecule [reportName]="" [dynamic_headers]="dynamicHeaders" [data]="data"
            *ngIf="tableDataFetched" [freezeColumns]="0"></app-grid-reusable-molecule>
    </div>
</div>